import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type DeviceStatusListData } from '../services/getDeviceStatusService'

export interface DeviceStatusDataState {
  isLoading: boolean
  loadingError: string | undefined
  DeviceStatusListData: DeviceStatusListData[] | undefined
  httpStatus: number | undefined
}

// Initial state of the slice
const initialState: DeviceStatusDataState = {
  isLoading: false,
  loadingError: undefined,
  DeviceStatusListData: undefined,
  httpStatus: undefined
}

// Slice to return from action
export const DeviceStatusDataListState = createSlice({
  name: 'DeviceStatusListData',
  initialState,
  reducers: {
    DeviceStatusLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: true,
        loadingError: undefined,
        DeviceStatusListData: undefined,
        httpStatus: 0
      }
    },
    DeviceStatusUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        isLoading: false,
        loadingError: undefined,
        DeviceStatusListData: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    DeviceStatusErrorAction: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload,
        httpStatus: action.payload.httpStatus,
        DeviceStatusListData: undefined
      }
    }
  }
})

// Actions to export
export const {
  DeviceStatusLoadingAction,
  DeviceStatusUpdateAction,
  DeviceStatusErrorAction
} = DeviceStatusDataListState.actions

export default DeviceStatusDataListState.reducer
